<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div v-if="name === 'btPesquisar'" class="crud-title">
              <translate>SEARCH_RECORDS</translate>
            </div>
            <div v-else-if="name === 'btNovo'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
          </q-card-section>
          <q-card-section>
            <jt-dynamic-form
              ref="dynamicForm"
              :inputs="elements[0].inputs"
              :relacionamentos="elements[0].relacionamentos"
              :model="elements[0].dadosForm"
              :interface="elements[0].nmInterface"
              form-class="form"
              class="contactPersonForms"
            />
            <section class="contactPersonTabs">
              <q-tabs
                id="phones-tab"
                v-model="tab"
                align="start"
                color="dark"
                dense
                active-color="primary"
                indicator-color="primary"
              >
                <q-tab
                  :label="$gettext('PHONE')"
                  key="phones"
                  name="phones"
                  default
                />
              </q-tabs>
              <q-separator />
              <q-tab-panels v-model="tab" animated>
                <q-tab-panel
                  key="phones"
                  name="phones"
                  class="row q-gutter-x-md"
                >
                  <span
                    v-for="(tel, index) in formModel.contactPersonPhones"
                    v-bind:key="index"
                    class="col-3"
                  >
                    <jt-tel-input
                      :float-label="$gettext('PHONE')"
                      :key="index"
                      v-model="tel.phone"
                      :clearable="true"
                      @input="setEditable(tel)"
                    />
                  </span>
                  <q-btn
                    class="bg-blue-grey text-white full-height q-py-sm"
                    icon="add"
                    @click="phoneAdd"
                  ></q-btn>
                </q-tab-panel>
              </q-tab-panels>
              <q-tabs
                id="emails-tab"
                v-model="tab2"
                align="start"
                color="dark"
                dense
                active-color="primary"
                indicator-color="primary"
              >
                <q-tab
                  :label="$gettext('EMAIL')"
                  key="emails"
                  name="emails"
                  default
                />
              </q-tabs>
              <q-separator />
              <q-tab-panels v-model="tab2" animated>
                <q-tab-panel
                  key="emails"
                  name="emails"
                  class="row q-gutter-x-md"
                >
                  <span
                    v-for="(em, index) in formModel.contactPersonEmails"
                    v-bind:key="index"
                    class="col-5"
                  >
                    <jt-email-input
                      :float-label="$gettext('EMAIL')"
                      :key="index"
                      v-model="em.email"
                      @input="setEditable(em)"
                    />
                  </span>
                  <q-btn
                    class="bg-blue-grey text-white full-height q-py-sm"
                    icon="add"
                    @click="emailAdd"
                  ></q-btn>
                </q-tab-panel>
              </q-tab-panels>
            </section>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-py-lg"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButtonEdit(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtechMessage } from 'src/plugins/system.messages'
import { validate } from 'vue-convenia-util'
import {
  JtDynamicForm,
  JtTelInput,
  JtEmailInput,
  JtCrud
} from 'jtech-webcomps'
const { page } = JtCrud
@Component({
  mixins: [page],
  name: 'ContactPersonPage',
  components: {
    JtDynamicForm,
    JtTelInput,
    JtEmailInput
  },
  props: {}
})
export default class ContactPersonPage extends Vue {
  tab = 'phones';
  tab2 = 'emails';
  formModel = {};
  utilValidate = null;
  get form () {
    return this.elements[0]
  }

  hasDuplicates (array) {
    return (new Set(array)).size !== array.length
  }

  hasDuplicatedEmails () {
    const emailStrings = this.formModel.contactPersonEmails.map((contactEmail) => {
      if (contactEmail.email) {
        return contactEmail.email
      }
    }).filter((email) => {
      return email
    })

    const isDuplicatedEmails = this.hasDuplicates(emailStrings)
    if (isDuplicatedEmails) {
      JtechMessage.error(this.$gettext('DUPLICATE_EMAIL_MESSAGE'))
    }
    return isDuplicatedEmails
  }

  hasDuplicatedPhones () {
    const phones = this.formModel.contactPersonPhones.map((contactPhone) => {
      return contactPhone.phone
    })
    const isDuplicatedPhones = this.hasDuplicates(phones)
    if (isDuplicatedPhones) {
      JtechMessage.error(this.$gettext('DUPLICATE_PHONE_MESSAGE'))
    }
    return isDuplicatedPhones
  }

  validateEmails (emails) {
    let isValidEmails = true
    const validateEmail = this.utilValidate
    emails.forEach((email) => {
      if (isValidEmails) {
        isValidEmails = validateEmail.isEmail(email)
      }
    })
    return isValidEmails
  }

  removeNullvariables (array, atributeNull) {
    return array.filter((item) => {
      return item[atributeNull]
    })
  }

  validatePhones (phones) {
    let isValidPhone = true
    const regex = /^[+]?[(]?[0-9]{2}[)]?[-\s.]?[0-9]{4,5}[-\s.]?[0-9]{4}$/im

    phones.forEach(phone => {
      if (isValidPhone) {
        isValidPhone = phone.match(regex)
      }
    })

    return isValidPhone
  }

  actionButtonEdit (button) {
    if (button.name == 'btAlterar') {
      this.formModel.contactPersonEmails = this.removeNullvariables(this.formModel.contactPersonEmails, 'email')
      this.formModel.contactPersonPhones = this.removeNullvariables(this.formModel.contactPersonPhones, 'phone')
      if (!this.hasDuplicatedEmails() && !this.hasDuplicatedPhones()) {
        const emails = this.formModel.contactPersonEmails.map(contactPersonEmail => contactPersonEmail.email)
        const isValidEmails = this.validateEmails(emails)

        const phones = this.formModel.contactPersonPhones.map(contactPersonPhone => contactPersonPhone.phone)
        const isValidPhones = this.validatePhones(phones)

        if (isValidEmails && isValidPhones) {
          this.actionButton(button)
        } else {
          JtechMessage.error(this.$gettext('INVALID_MESSAGE'))
        }
      }
    } else {
      this.actionButton(button)
    }
  }

  beforeMount () {
    this.utilValidate = validate
    this.renderForm = true
    this.form.inputs = this.form.inputs.filter((i) => i.type != 'COMPOSICAO')
    this.formModel = this.form.dadosForm
    this.params.idAcaoGrid = this.params.id
    if (!this.formModel.name) {
      this.$set(this.formModel, 'name', '')
    }
    if (!this.formModel.contactPersonPhones) {
      this.$set(this.formModel, 'contactPersonPhones', [])
    }
    if (!this.formModel.contactPersonEmails) {
      this.$set(this.formModel, 'contactPersonEmails', [])
    }
  }

  phoneAdd () {
    this.formModel.contactPersonPhones.push({ phone: '' })
  }

  emailAdd () {
    this.formModel.contactPersonEmails.push({ email: '' })
  }

  setEditable (object) {
    if (object.id) object.flAlterado = 'S'
  }

  removeEmailEmpty () {
    let i = 0
    let length = this.formModel.contactPersonEmails.length

    while (i < length) {
      if (
        this.formModel.contactPersonEmails[i].email === null ||
          this.formModel.contactPersonEmails[i].email === ''
      ) {
        this.formModel.contactPersonEmails.splice(i, 1)
        length--
      } else {
        i++
      }
    }
  }

  removePhoneEmpty () {
    let i = 0
    let length = this.formModel.contactPersonPhones.length

    while (i < length) {
      if (
        this.formModel.contactPersonPhones[i].phone === null ||
          this.formModel.contactPersonPhones[i].phone === ''
      ) {
        this.formModel.contactPersonPhones.splice(i, 1)
        length--
      } else {
        i++
      }
    }
  }
}
</script>
<style lang="stylus" scoped></style>
